module.exports = __webpack_public_path__ + "static/media/agent4.81321155.png";